module.exports = __webpack_public_path__ + "static/media/eh.e4f13505.svg";